import { FC, SVGProps } from "react";
import classes from "./style.module.css";
import classNames from "classnames";

const RollingLoader: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid"
      {...props}
      className={classNames(props.className, classes.spin)}
    >
      <circle
        cx="50"
        cy="50"
        fill="none"
        stroke="currentColor"
        strokeWidth="10"
        r="35"
        strokeDasharray="164.93361431346415 56.97787143782138"
        opacity="0.5"
      />
    </svg>
  );
};

export default RollingLoader;
